module.exports = __webpack_public_path__ + "img/de.604a1b7.png";